module.exports = __webpack_public_path__ + "img/The-Field-BG.aeb8c45b.jpg";